<div class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">

    <!-- Premium Header Area -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
                ชั้นที่ตั้งบริษัทผู้เช่า</h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
                จัดการข้อมูลชั้นจอดรถและตำแหน่งที่ตั้งรายพื้นที่</p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 hover:text-amber-500 transition-all active:scale-95 flex items-center justify-center h-[46px]"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="openCreateModal()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 h-[46px]">
                <span class="material-icons text-xl">add_circle</span>
                เพิ่มชั้นใหม่
            </button>
        </div>
    </div>

    <!-- Dashboard stats (Glassmorphic) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div *ngFor="let stat of stats; let i = index"
            class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-300 group relative overflow-hidden"
            [style.animation-delay]="(i * 100) + 'ms'">

            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm transition-transform group-hover:scale-110"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl">{{ stat.icon }}</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-[10px] font-black uppercase tracking-wider mb-1 truncate">{{ stat.title
                    }}</h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                    {{ stat.value | number }}
                </div>
            </div>
        </div>
    </div>

    <!-- Main Content Card (Glassmorphic) -->
    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay: 0.2s;">

        <!-- Search & Control Header -->
        <div
            class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">layers</span>
                ตารางข้อมูลชั้นบริษัทผู้เช่า
            </h3>

            <div class="flex flex-col lg:flex-row gap-3 w-full xl:w-auto">
                <!-- Area Filter Dropdown -->
                <div class="relative min-w-[180px]">
                    <button (click)="toggleAreaDropdown()"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">place</span>
                            {{ filterArea || 'ทั้งหมด (พื้นที่)' }}
                        </span>
                        <span class="material-icons text-sm text-slate-400"
                            [class.rotate-180]="isAreaDropdownOpen">expand_more</span>
                    </button>
                    <div *ngIf="isAreaDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 z-40 animate-fade-in-up">
                        <div (click)="selectAreaFilter('')"
                            class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer">ทุกพื้นที่</div>
                        <div *ngFor="let area of areaOptions" (click)="selectAreaFilter(area)"
                            class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer">{{ area }}</div>
                    </div>
                </div>

                <!-- Status Filter Dropdown -->
                <div class="relative min-w-[150px]">
                    <button (click)="toggleStatusDropdown()"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">offline_pin</span>
                            {{ filterStatus === 'online' ? 'Online' : filterStatus === 'offline' ? 'Offline' : 'ทั้งหมด
                            (สถานะ)' }}
                        </span>
                        <span class="material-icons text-sm text-slate-400"
                            [class.rotate-180]="isStatusDropdownOpen">expand_more</span>
                    </button>
                    <div *ngIf="isStatusDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 z-40 animate-fade-in-up">
                        <div (click)="selectStatusFilter('')"
                            class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer">ทั้งหมด</div>
                        <div (click)="selectStatusFilter('online')"
                            class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer text-emerald-600">Online
                        </div>
                        <div (click)="selectStatusFilter('offline')"
                            class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer text-rose-600">Offline
                        </div>
                    </div>
                </div>

                <!-- Lots Filter (Minimum Input) -->
                <div class="relative min-w-[150px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 focus-within:bg-white h-[46px] shadow-sm transition-all overflow-hidden px-3">
                        <span class="material-icons text-slate-400 text-lg mr-2">meeting_room</span>
                        <input type="number" [(ngModel)]="filterMinLots" (input)="applyFilters()"
                            placeholder="ขั้นต่ำจำนวนที่จอด (Lot)"
                            class="w-full bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:ring-0 outline-none">
                    </div>
                </div>

                <!-- Search Input -->
                <div class="relative flex-1 flex w-full lg:min-w-[300px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
                        <span class="absolute left-4 material-icons text-slate-400 text-xl">search</span>
                        <input type="text" placeholder="ค้นหาชื่อชั้น, ประเภท..." [(ngModel)]="searchText"
                            (input)="applyFilters()"
                            class="w-full pl-12 pr-4 py-2 bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:ring-0 outline-none placeholder:text-slate-400">
                    </div>
                </div>
            </div>
        </div>

        <!-- Table Container -->
        <div class="overflow-x-auto min-h-[500px] relative custom-scrollbar">
            <app-pss-loading *ngIf="isLoading"></app-pss-loading>

            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm border-b border-slate-100 dark:border-slate-700">
                    <tr class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">
                        <th (click)="sortData('name')"
                            class="p-6 pl-10 cursor-pointer hover:text-amber-500 transition-colors group">
                            <div class="flex items-center gap-1">
                                ชื่อ
                                <span
                                    class="material-icons text-xs transition-all opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'name'">
                                    {{ sortColumn === 'name' && sortDirection === 'desc' ? 'south' : 'north' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('parkingType')"
                            class="p-6 cursor-pointer hover:text-amber-500 transition-colors group">
                            <div class="flex items-center gap-1">
                                ประเภทที่จอดรถ
                                <span
                                    class="material-icons text-xs transition-all opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'parkingType'">
                                    {{ sortColumn === 'parkingType' && sortDirection === 'desc' ? 'south' : 'north' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('lots')"
                            class="p-6 text-center cursor-pointer hover:text-amber-500 transition-colors group">
                            <div class="flex items-center justify-center gap-1">
                                จำนวนที่จอด (Lot)
                                <span
                                    class="material-icons text-xs transition-all opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'lots'">
                                    {{ sortColumn === 'lots' && sortDirection === 'desc' ? 'south' : 'north' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('serviceArea')"
                            class="p-6 cursor-pointer hover:text-amber-500 transition-colors group">
                            <div class="flex items-center gap-1">
                                พื้นที่ให้บริการ
                                <span
                                    class="material-icons text-xs transition-all opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'serviceArea'">
                                    {{ sortColumn === 'serviceArea' && sortDirection === 'desc' ? 'south' : 'north' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-6 text-center">รูปภาพตัวอย่าง</th>
                        <th (click)="sortData('isOnline')"
                            class="p-6 text-center cursor-pointer hover:text-amber-500 transition-colors group">
                            <div class="flex items-center justify-center gap-1">
                                สถานะ
                                <span
                                    class="material-icons text-xs transition-all opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'isOnline'">
                                    {{ sortColumn === 'isOnline' && sortDirection === 'desc' ? 'south' : 'north' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-6 text-center">จัดการ</th>
                        <th class="p-6 pr-10 text-center">
                            <div class="flex flex-col items-center gap-2">
                                <span class="text-[9px]">เลือกทั้งหมด</span>
                                <div (click)="toggleAll($event)"
                                    class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border cursor-pointer select-none shadow-sm"
                                    [ngClass]="(filteredList.length > 0 && selectedIds.size === filteredList.length) ? 'bg-amber-400 border-amber-400 text-white' : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-transparent hover:border-amber-300'">
                                    <span class="material-icons text-sm font-black">check</span>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let item of filteredList"
                        class="group hover:bg-amber-50/30 dark:hover:bg-slate-700/40 transition-all duration-200 cursor-pointer animate-table-row"
                        [class.bg-amber-50]="selectedIds.has(item.id)" (click)="toggleItem(item.id)">

                        <td class="p-6 pl-10">
                            <span
                                class="text-sm font-black text-slate-700 dark:text-slate-100 group-hover:text-amber-600 transition-colors">{{
                                item.name }}</span>
                        </td>

                        <td class="p-6">
                            <span
                                class="px-3 py-1 bg-slate-100 dark:bg-slate-900 rounded-lg text-xs font-bold text-slate-500">{{
                                item.parkingType }}</span>
                        </td>

                        <td class="p-6 text-center">
                            <span class="text-sm font-black text-slate-700 dark:text-slate-200">{{ item.lots | number
                                }}</span>
                        </td>

                        <td class="p-6">
                            <span
                                class="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-50 dark:bg-amber-900/10 text-amber-600 dark:text-amber-400 text-[10px] font-black rounded-lg border border-amber-100/50 uppercase tracking-widest">
                                <span class="material-icons text-[12px]">place</span>
                                {{ item.serviceArea }}
                            </span>
                        </td>

                        <!-- Unified Image Gallery Column -->
                        <td class="p-6">
                            <div class="flex items-center justify-center gap-2">
                                <div *ngFor="let img of [item.image1, item.image2, item.image3]" class="relative">
                                    <div *ngIf="img; else noImg"
                                        class="w-16 h-12 rounded-lg border border-slate-200 shadow-sm overflow-hidden hover:scale-110 transition-transform z-10 hover:z-20">
                                        <img [src]="img" class="w-full h-full object-cover">
                                    </div>
                                    <ng-template #noImg>
                                        <div
                                            class="w-16 h-12 bg-slate-50 border border-slate-200 rounded-lg flex items-center justify-center opacity-30">
                                            <span class="material-icons text-xl">camera_alt</span>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </td>

                        <td class="p-6 text-center" (click)="$event.stopPropagation()">
                            <div class="flex justify-center">
                                <div class="relative inline-flex items-center cursor-pointer"
                                    (click)="toggleStatusLive(item)">
                                    <input type="checkbox" class="sr-only peer" [checked]="item.isOnline">
                                    <div
                                        class="w-11 h-6 bg-slate-200 peer-focus:outline-none dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-slate-600 peer-checked:bg-emerald-500 rounded-full shadow-inner">
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td class="p-6 text-center" (click)="$event.stopPropagation()">
                            <button (click)="openEditModal(item)"
                                class="inline-flex items-center justify-center w-10 h-10 rounded-2xl text-blue-500 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 hover:text-white transition-all shadow-sm hover:scale-110">
                                <span class="material-icons text-sm">edit</span>
                            </button>
                        </td>

                        <td class="p-6 pr-10 text-center" (click)="$event.stopPropagation()">
                            <div class="flex items-center justify-center">
                                <div (click)="toggleItem(item.id)"
                                    class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border cursor-pointer select-none"
                                    [ngClass]="selectedIds.has(item.id) ? 'bg-amber-400 border-amber-400 text-white shadow-amber-200 shadow-lg' : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-transparent hover:border-amber-300'">
                                    <span class="material-icons text-sm font-black">check</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-floor-tenant-company *ngIf="isModalOpen" [data]="selectedItem" (close)="closeModal()"
        (saveSuccess)="onRefresh()"></app-modal-floor-tenant-company>

</div>